import { lazy, Suspense } from "react";

// sonner (toast UI) is only needed after a user action (form submit, errors).
// Loading it lazily keeps ~20 KB of toast machinery out of the first-boot
// bundle; the toast() calls themselves are imported by the form components,
// which live in route chunks — so nothing user-facing changes.
const SonnerToaster = lazy(() =>
  import("./sonner").then((m) => ({ default: m.Toaster }))
);

export function Toaster(props) {
  return (
    <Suspense fallback={null}>
      <SonnerToaster {...props} />
    </Suspense>
  );
}
